import Pills from "./Pills";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default Pills;
